/** @format */

import {Link} from 'react-router-dom';
import React from 'react';

export const InvoiceActionColumn = props => {
    const {cart} = props;
    return (
        <div className="orders-list-table-active-31cs__column--action">
            <Link
                className="color-accent-primary d-inline-flex align-items-center justify-content-start gap-2"
                to={`/account/orders/preview-current-invoice/${cart.id}`}
                rel={'noopener noreferrer'}
                target={'_blank'}>
                <i className="fa fa-eye mt-1" />
                <u>View invoice</u>
            </Link>
        </div>
    );
};
